import {NullableType} from "./Tools";
import {isMobile, isPasswordReset, isReturnFromPayment} from './PureTools';
import {homebaseLocationData} from './Constants';
import {flmVersion, LATEST_BIG_CHANGE_VERSION} from './version';
import {DateFilterType, FlightType, LatLngType, LoginType} from "./actions/action";
import {createStore} from "redux";
import {rootReducer} from "./reducers";

declare var window: any;


export interface Location {
    continent: string,
    lat: number,
    airportName: string,
    climate: string,
    lng: number,
    city: string,
    country: string,
    icao: string
}

export interface LocationsType {
    [key: string]: Location
}

let locationsObject: LocationsType = {
    hel: homebaseLocationData
};
let picObject = {};

const storedVersion = localStorage.getItem('version') || '0';
//this is run after Tools.js
//Tools.js does version check for its own purposes
const seenVersion: string = storedVersion.startsWith('20')
    ? storedVersion
    : '0';
localStorage.setItem('version', '' + flmVersion);

interface PositionType {
    x: number | null,
    y: number | null
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface HoveredCityType {
    hoveredCity: string | null,
    hoveredCityPosition: PositionType,
    flights: FlightType[]
}

export interface HoveredFlightType {
    hoveredFlightPosition: PositionType,
    flight: FlightType
}

export interface StateBaseType {
    reducer: StateType,
    lastAction: {type: any, payload: any}
}

export interface StateType {
    allFlights: FlightType[],
    flights: FlightType[],
    locations: LocationsType,
    pics: any,
    veil: boolean,
    editFlightNumber: number,
    isFilter: boolean,
    showGlobe: number,
    showMenu: boolean,
    showTableNumber: number,
    showCharts: number,
    showStats: boolean,
    showShowcase: NullableType<FlightType>,
    showTutorial: boolean,
    showSettings: boolean,
    showRegister: boolean,
    showReset: boolean,
    showVerify: boolean,
    showMatrix: boolean,
    showFeedback: boolean,
    showMapSelection: boolean,
    showWhatsNew: boolean,
    spinner: boolean,
    showLogin: boolean,
    incompleteQueue: string[],
    dateFilter: DateFilterType,
    airlineFilter: string,
    purposeFilter: string,
    modelFilter: string,
    filterApplied: boolean,
    hoveredCity: any,
    hoveredFlight: any,
    centerMap: boolean,
    user: NullableType<LoginType>,
    mapType: number,
    windowWidth: number,
    windowHeight: number,
    mapReferenceGoogle: any,
    mapZoomGoogle: number,
    mapReferenceLeaflet: any,
    mapZoomLeaflet: number,
    markerPosition: NullableType<LatLngType>,
    showSearch: boolean,
    showMore: boolean,
    showConsent: boolean,
    showPolicy: boolean,
    showAddAirline: boolean,
    unverifiedEmail: string,
    welcomeState: number
}

export const defaultState: any = {
    reducer: {
        allFlights: [],
        flights: [],
        locations: locationsObject,
        pics: picObject,
        veil: true,
        editFlightNumber: -1,
        isFilter: false,
        showGlobe: -1,
        showMenu: false,
        showTableNumber: -1,
        showCharts: -1,
        showStats: !isMobile,
        showShowcase: false,
        showFeedback: false,
        showMapSelection: false,
        showTutorial: false,
        showSettings: false,
        showRegister: false,
        showReset: isPasswordReset,
        showVerify: false,
        showMatrix: false,
        showWhatsNew: seenVersion !== '0' && seenVersion < flmVersion && seenVersion < LATEST_BIG_CHANGE_VERSION,
        spinner: false,
        showLogin: !isReturnFromPayment,
        incompleteQueue: [],
        dateFilter: null,
        airlineFilter: '***',
        purposeFilter: '***',
        modelFilter: '***',
        filterApplied: false,
        hoveredCity: {
            hoveredCity: null,
            hoveredCityPosition: {
                x: null,
                y: null
            },
            flights: []
        },
        hoveredFlight: {
            hoveredFlightPosition: {
                x: null,
                y: null
            },
            flight: null
        },
        centerMap: false,
        user: null,
        mapType: 0,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        mapReferenceGoogle: null,
        mapZoomGoogle: 3,
        mapReferenceLeaflet: null,
        mapZoomLeaflet: 3,
        markerPosition: null,
        showSearch: false,
        showMore: false,
        showConsent: false,
        showPolicy: false,
        showAddAirline: false,
        unverifiedEmail: ''
    },
    lastAction: {type: null, payload: null}
};

const store = createStore(rootReducer,
    defaultState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default store;
